"use strict";
//# sourceMappingURL=options.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-notifications/lib/options.js
// module id = 597
// module chunks = 0